import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { setToken } from '@/api/client';

export default function Login() {
  const [token, setTokenInput] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!token.trim()) {
      setError('Token is required');
      return;
    }

    // Verify token by hitting stats endpoint
    try {
      const res = await fetch('/api/stats', {
        headers: { Authorization: `Bearer ${token.trim()}` },
      });
      if (res.ok) {
        setToken(token.trim());
        navigate('/');
      } else {
        setError('Invalid token');
      }
    } catch {
      setError('Failed to connect to server');
    }
  };

  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--bg-0)',
    }}>
      <form onSubmit={handleSubmit} style={{
        background: 'var(--bg-1)',
        border: '1px solid var(--border)',
        borderRadius: 12,
        padding: 40,
        width: 400,
        textAlign: 'center',
      }}>
        <div style={{ fontSize: 48, marginBottom: 12 }}>🧠</div>
        <h1 style={{ fontSize: 24, fontWeight: 700, marginBottom: 4 }}>OpenClaw Control</h1>
        <p style={{ color: 'var(--text-2)', fontSize: 13, marginBottom: 24 }}>
          Enter your admin token to continue
        </p>

        <input
          type="password"
          placeholder="Admin token"
          value={token}
          onChange={e => { setTokenInput(e.target.value); setError(''); }}
          style={{
            width: '100%',
            padding: '10px 14px',
            background: 'var(--bg-2)',
            border: `1px solid ${error ? 'var(--red)' : 'var(--border)'}`,
            borderRadius: 8,
            color: 'var(--text-0)',
            fontSize: 14,
            marginBottom: error ? 8 : 16,
            outline: 'none',
          }}
        />

        {error && (
          <p style={{ color: 'var(--red)', fontSize: 13, marginBottom: 12 }}>{error}</p>
        )}

        <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }}>
          Sign In
        </button>
      </form>
    </div>
  );
}
